var map = {
	"./cnn-money-x2.png": 2043,
	"./economist-x2.png": 2044,
	"./mashable-x2.png": 2045,
	"./tech-crunch-x2.png": 2046,
	"./thenewyorker-x2.png": 2047,
	"./thrillist-x2.png": 2048,
	"./time-x2.png": 2049,
	"./usa-today-x2.png": 2050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2256;